import { Component, Input } from '@angular/core';
import { Course } from '../../interfaces/course';

@Component({
  selector: 'app-course-item',
  templateUrl: './course-item.component.html',
  styleUrls: ['./course-item.component.scss', './course-item.component.en.scss']
})
export class CourseItemComponent {
  @Input() data!: Course;

  @Input({ required: true }) linkTitle!: string;
  @Input({ required: true }) creditsText!: string;
  opened: boolean = false;
}
